<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          NO: {{ formData.resFabricPurchaseNo || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.resFabricPurchaseStatus === 'R'
              ? 'success'
              : formData.resFabricPurchaseStatus === 'Y'
              ? 'warning'
              : formData.resFabricPurchaseStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.resFabricPurchaseStatusName }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify: {{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('table_lable_purchaseDate') || '采购日期'"
            prop="purchaseDate"
          >
            <el-date-picker
              v-model="formData.purchaseDate"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('table_lable_expectedDeliveryDate') || '期望到货日期'"
            prop="expectedDeliveryDate"
          >
            <el-date-picker
              v-model="formData.expectedDeliveryDate"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.purchase_form_label_scmCode') || '供应商'"
            prop="resScmCode"
          >
            <dict-select
              v-model="formData.resScmCode"
              url="/master/common/dict/scm"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('table_lable_resFabricScmName') || '厂家店铺'"
            prop="resFabricScmCode"
          >
            <dict-select
              v-model="formData.resFabricScmCode"
              url="/digitalCenter/res/fabric/scm/fabric/scm/dict"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_fabricAmount') || '总面料金额'">
            <el-input v-model="v_fabricAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_totalSurchargeAmount') || '总附加费金额'"
          >
            <el-input v-model="v_surchargeAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('table_label_amount') || '采购金额'">
            <el-input v-model="v_totalAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ItemTable
          class="mt-1"
          ref="itemTable"
          :disabled="disabled"
          :resFabricPurchaseCode="resFabricPurchaseCode"
          @updateTotAmount="updateTotAmount"
          :depCode="salesPersonInfo.depCode"
          :orgDepFullName="salesPersonInfo.orgDepFullName"
          :substituteInvoice="formData.substituteInvoice"
        />
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
export default {
  components: { ItemTable },
  mixins: [EditLoading],
  props: {
    resFabricPurchaseCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      formData: {
        totalAmount: 0,
        surchargeAmount: 0,
        fabricAmount: 0,
      },
      rules: {
        purchaseDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        expectedDeliveryDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        resScmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        resFabricScmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
      },
      salesPersonInfo: {},
    }
  },
  computed: {
    v_totalAmount() {
      const { totalAmount } = this.formData
      return !totalAmount ? '0' : totalAmount.toLocaleString()
    },
     v_surchargeAmount() {
      const { surchargeAmount } = this.formData
      return !surchargeAmount ? '0' : surchargeAmount.toLocaleString()
    },
     v_fabricAmount() {
      const { fabricAmount } = this.formData
      return !fabricAmount ? '0' : fabricAmount.toLocaleString()
    },
  },
  watch: {},
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    reload() {
      this.getData()
      this.$refs.itemTable.loadData()
    },
    updateTotAmount(e){
        this.formData.fabricAmount = e.fabricAmount || 0
        this.formData.surchargeAmount = e.surchargeAmount || 0
        this.formData.totalAmount = e.totalAmount || 0
    },
    getData() {
      if (!this.resFabricPurchaseCode) return
      this.$api
        .resFabricPurchaseProcureDetailApi({
          resFabricPurchaseCode: this.resFabricPurchaseCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await this.formValidate()
      if (!result) return
      const listItem = this.$refs.itemTable.getTableData()
      const delCodeList = this.$refs.itemTable.getDelCodeList()

      const param = {
        ...this.formData,
        listItem,
        delCodeList,
      }
      if (!listItem || listItem.length < 1) {
        this.$confirm(
          '产品明细列表为空，是否要删除该采购记录？',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText:
              this.$l('INDEX.product_dialog_btn_confirm') || '确定',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
          }
        ).then(() => {
          this.procureSave(param)
        })
        return
      }
      this.procureSave(param)
    },
    procureSave(param) {
      this.loadingOpen()
      this.$api
        .resFabricPurchaseProcureSaveApi({
          ...param,
        })
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.closeCurPage()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
